import React, { useState } from 'react';
import { Lock, Eye, EyeOff } from 'lucide-react';
import { Button } from '../ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const PANTHERS_LOGO =
  'https://customer-assets.emergentagent.com/job_panthers-league/artifacts/h32tep3p_New%20Panthers%20Logo.jpg';

const LoginScreen = ({ onAuthenticated }) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [authError, setAuthError] = useState('');
  const [authLoading, setAuthLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setAuthLoading(true);
    setAuthError('');

    try {
      const response = await fetch(
        `${API_URL}/api/admin/verify?password=${encodeURIComponent(password)}`,
        { method: 'POST' }
      );
      const data = await response.json();
      if (data.success) {
        onAuthenticated();
      } else {
        setAuthError('Invalid password. Please try again.');
      }
    } catch {
      setAuthError('Connection error. Please try again.');
    } finally {
      setAuthLoading(false);
    }
  };

  return (
    <div className="admin-container">
      <div className="login-screen">
        <div className="login-card">
          <img src={PANTHERS_LOGO} alt="Panthers Logo" className="login-logo" />
          <h1 className="login-title">Admin Dashboard</h1>
          <p className="login-subtitle">Randallstown Youth Football & Cheer</p>

          <form onSubmit={handleLogin} className="login-form">
            {authError && <div className="auth-error">{authError}</div>}

            <div className="password-input-wrapper">
              <Lock size={20} className="input-icon" />
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter admin password"
                required
                disabled={authLoading}
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>

            <Button type="submit" className="login-btn" disabled={authLoading}>
              {authLoading ? 'Verifying...' : 'Access Dashboard'}
            </Button>
          </form>

          <a href="/" className="back-to-site">← Back to Website</a>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
